import { useMemo, useState } from "react";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";
import { useNavigate } from "react-router-dom";

import { apiOutletClient, getErrorMessage } from "@/features/shared";
import {
  DEFAULT_VALUES,
  StockAdjustmentForm,
} from "@/features/stock-adjustments";
import { useSnackbar } from "@/features/ui";

export const CreateStockAdjustment = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const defaultValues = useMemo(() => {
    const outlet = JSON.parse(localStorage.getItem("outlet") || "null");
    return { ...DEFAULT_VALUES, outlet };
  }, []);

  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      const { outletId, ...payload } = data;

      await apiOutletClient.post("stock-adjustments", payload, {
        headers: { "Outlet-Id": outletId },
      });

      showSnackbar("Penyesuaian stok berhasil dibuat", "success");
      navigate("/inventory/stock-adjustments");
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal membuat penyesuaian stok"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Penyesuaian Stok"
      breadcrumbs={[
        {
          title: "Penyesuaian Stok",
          path: "/inventory/stock-adjustments",
        },
        { title: "Buat" },
      ]}
    >
      <StockAdjustmentForm
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        onImported={({ referenceNumber }) =>
          navigate(`/inventory/stock-adjustments/${referenceNumber}`)
        }
        renderActionButton={() => (
          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            size="large"
          >
            {isSubmitting ? "Menyimpan..." : "Simpan"}
          </Button>
        )}
      />
    </PageContainer>
  );
};
